export default __webpack_public_path__ + "static/media/vectorplotter.e17d92d9.mp4";